import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterService } from '../../../services/toaster.service';
import { ApiService } from '../../../services/api.service';
import { AuthService } from '../../../services/auth.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { routes } from '../../../constants/routes';
import { apiErrorHandler } from '../../../constants/api-error-handler';
import { ApiErrorHandler } from '../../../models/api-error-handler.model';
import { pageSeoInfo } from '../../../constants/page-seo-info';
import { SeoService } from '../../../services/seo.service';

@Component({
  selector: 'app-loading-page',
  standalone: true,
  imports: [MatProgressBarModule],
  templateUrl: './loading-page.component.html',
  styleUrl: './loading-page.component.scss',
})
export class LoadingPageComponent implements OnInit, ApiErrorHandler {
  private decryptProfileSubs?: Subscription;

  constructor(
    public location: Location,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public toaster: ToasterService,
    private apiService: ApiService,
    private authService: AuthService,
    private seoService: SeoService,
  ) {}

  ngOnInit() {
    this.evaluateData();
    console.log('CALLED FROM LOADING PAGE');

    const { title, description, canonicalUrl } = pageSeoInfo['loading'];
    this.seoService.setPageTitle(title);
    this.seoService.setPageDescription(description);
    this.seoService.setCanonicalUrl(canonicalUrl);
  }

  private evaluateData() {
    const { success, data } = <{ success?: 'y' | 'n'; data?: string }>(
      (this.activatedRoute.snapshot.queryParams || {})
    );

    const redirectToLogin = () => {
      this.router.navigate(['/', routes.account, routes.login], {
        replaceUrl: true,
      });
    };

    switch (success?.toLowerCase()) {
      case 'y': {
        this.decryptUserProfile(data!);
        break;
      }
      case 'n': {
        redirectToLogin();
        this.toaster.error(data);
        break;
      }
      default: {
        redirectToLogin();
        break;
      }
    }
  }

  private decryptUserProfile(data: string) {
    this.decryptProfileSubs = this.apiService
      .decrypyUserProfile(data)
      .subscribe({
        next: (profile) => {
          this.authService.saveUserProfile(profile);
          this.authService.redirectToDashboard();
        },
        error: apiErrorHandler.bind(this),
      });
  }

  ngOnDestroy() {
    this.decryptProfileSubs?.unsubscribe();
  }
}
